module.exports = __webpack_public_path__ + "img/2.62de839f.png";